import React, { useState } from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import ReviewsIcon from '@mui/icons-material/Reviews';
import VerifiedIcon from '@mui/icons-material/Verified';
import { motion } from 'framer-motion';

const Content = () => {
  const [selectedCard, setSelectedCard] = useState(null);

  const cardData = [
    { title: 'SCIENCE', icon: <SupportAgentIcon sx={{ mr: 2, fontSize: '32px' }} /> },
    { title: 'COMMERCE', icon: <ReviewsIcon sx={{ mr: 2, fontSize: '32px' }} /> },
    { title: 'ARTS', icon: <VerifiedIcon sx={{ mr: 2, fontSize: '32px' }} /> },
  ];

  return (
    <Box sx={{ padding: { xs: 4, sm: 6, md: 8 }, background: 'var(--background-light)' }}>
      {/* Title Section */}
      <Box sx={{ mb: 6, textAlign: 'center' }}>
        <Typography
          variant="h3"
          sx={{
            fontSize: { xs: '32px', sm: '36px', md: '44px' },
            fontWeight: 800,
            color: 'var(--primary-dark)',
          }}
        >
          Get Admission in Top PU Colleges
        </Typography>
      </Box>

      {/* Quote Section */}
      <Box sx={{ maxWidth: '800px', mx: 'auto', mb: 8, textAlign: 'center' }}>
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Typography
            sx={{
              color: 'var(--text-secondary)',
              fontSize: { xs: '16px', sm: '18px', md: '20px' },
              fontStyle: 'italic',
              lineHeight: 1.8,
              position: 'relative',
              display: 'inline-block',
              padding: '0 40px'
            }}
          >
            <FormatQuoteIcon sx={{ color: 'var(--primary-color)', fontSize: '40px', position: 'absolute', top: '-10px', left: 0, opacity: 0.3 }} />
            Choosing the top PU colleges ensures access to quality education, experienced faculty, and state-of-the-art facilities. These institutions provide a strong academic foundation, preparing students for prestigious universities and successful careers in various fields.
            <FormatQuoteIcon sx={{ color: 'var(--primary-color)', fontSize: '40px', position: 'absolute', bottom: '-10px', right: 0, opacity: 0.3 }} />
          </Typography>
        </motion.div>
      </Box>

      {/* Cards Section */}
      <Grid container spacing={4} justifyContent="center" maxWidth="1200px" mx="auto">
        {cardData.map((card, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.15, duration: 0.5 }}
            >
              <Card
                className="glass-card"
                sx={{
                  width: '100%',
                  height: '140px',
                  backgroundColor: selectedCard === index ? 'var(--primary-color)' : 'var(--background-light)',
                  color: selectedCard === index ? '#fff' : 'var(--primary-dark)',
                  cursor: 'pointer',
                  borderRadius: '16px',
                  border: selectedCard === index ? '1px solid var(--primary-color)' : '1px solid rgba(26, 35, 126, 0.1)',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: selectedCard === index ? '0 10px 30px rgba(26, 35, 126, 0.3)' : '0 4px 12px rgba(0,0,0,0.05)',
                  '&:hover': {
                    backgroundColor: 'var(--primary-dark)',
                    color: '#FFF',
                    transform: 'translateY(-5px)',
                    boxShadow: '0 15px 35px rgba(26, 35, 126, 0.2)',
                  },
                }}
                onMouseEnter={() => setSelectedCard(index)}
                onMouseLeave={() => setSelectedCard(null)}
              >
                <CardContent sx={{ textAlign: 'center', width: '100%', padding: '0 !important' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {card.icon}
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: { xs: '18px', sm: '20px', md: '22px' },
                        fontWeight: 700,
                        letterSpacing: '1px'
                      }}
                    >
                      {card.title}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Content;
